import type { Observable } from 'rxjs';
import type { AdminGeneralPage } from './admin-general.page';

/**
 * Blocks navigation away from the General page while the instructions hold
 * unsaved changes (another settings item, the back arrow, browser Back).
 * Delegates the decision to the page component, which prompts the user.
 *
 * Angular passes `null` as the component when the instance is not available at
 * guard-run time, as in `admin-teammates.can-deactivate.guard.ts`: nothing to
 * deactivate, so allow navigation.
 */
export const adminGeneralCanDeactivateGuard = (
  component: AdminGeneralPage | null,
): Observable<boolean> | boolean =>
  component ? component.canDeactivate() : true;
